export default __webpack_public_path__ + "static/media/1e1efe171dd451bd.758b564b10c82229f4c7e3e008abf73d.svg";